import styled from 'styled-components';

import { Button } from '../../../../../../components/Toolkit/Button';

const WhatsAppButton = styled(Button)`
  color: ${({ theme }) => theme.colors.GREEN};
  border-color: ${({ theme }) => theme.colors.GREEN};
  svg {
    margin-right: ${({ theme }) => `${theme.spacing.S8}`};
  }
  &:active,
  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.BLUE};
    }
    border-color: ${({ theme }) => theme.colors.BLUE};
  }
`;

const ButtonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${theme.spacing.S8}`};
`;

export { WhatsAppButton, ButtonList };
